import { Axios } from "../../Services/Axios";

export const login = async (payload) => {
  return await Axios.post("/admin/login", payload, { responseType: "json" });
};
